const playHeroVideo = (video) => {
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.loop = true;
  video.autoplay = true;
  const attempt = video.play();
  if (attempt && attempt.then) {
    attempt.then(() => video.classList.add('is-on')).catch(() => {});
  }
};

const setupHeroVideos = () => {
  document.querySelectorAll('.block-film video, .offer-film video, .bp-clip').forEach((video) => {
    if (video.dataset.heroReady) {
      playHeroVideo(video);
      return;
    }
    video.dataset.heroReady = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    playHeroVideo(video);
    video.addEventListener('canplay', () => playHeroVideo(video));
    video.addEventListener('loadeddata', () => playHeroVideo(video));
    video.addEventListener('pause', () => {
      if (document.hidden || video.ended) return;
      window.setTimeout(() => playHeroVideo(video), 80);
    });
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupHeroVideos);
} else {
  setupHeroVideos();
}
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) setupHeroVideos();
});

const setupSliders = () => {
  document.querySelectorAll('[data-slides]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-track]');
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = root.querySelector('[data-dots]');
    if (!track || !slides.length) return;
    let index = 0;
    let startX = 0;
    const existing = dots ? [...dots.querySelectorAll('button')] : [];
    if (!existing.length) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Photo ${i + 1}`);
        dots?.append(dot);
      });
    }
    const go = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots?.querySelectorAll('button').forEach((dot, i) => dot.classList.toggle('is-on', i === index));
    };
    dots?.querySelectorAll('button').forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    root.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
    root.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      if (dx > 40) go(index - 1);
      if (dx < -40) go(index + 1);
    }, { passive: true });
    go(0);
  });
};
const setupReviewSlider = () => {
  document.querySelectorAll('[data-reviews]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-track]');
    const slides = [...root.querySelectorAll('[data-rev]')];
    if (!track || !slides.length) return;
    let index = 0;
    const per = () => (root.clientWidth >= 901 ? 3 : 1);
    const maxIndex = () => Math.max(0, slides.length - per());
    const go = (next) => {
      const max = maxIndex();
      index = ((next % (max + 1)) + (max + 1)) % (max + 1);
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 18;
      const step = slides[0].getBoundingClientRect().width + gap;
      track.style.transform = `translate3d(-${index * step}px,0,0)`;
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
    let startX = 0;
    root.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      if (dx > 40) go(index - 1);
      if (dx < -40) go(index + 1);
    }, { passive: true });
    window.addEventListener('resize', () => go(index));
    go(0);
  });
};
const setupCustomerReviews = () => {
  const root = document.querySelector('.block-cr');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const cards = [...root.querySelectorAll('[data-cr-card]')];
  const search = root.querySelector('[data-cr-search]');
  const sort = root.querySelector('[data-cr-sort]');
  const load = root.querySelector('[data-cr-load]');
  const write = root.querySelector('[data-cr-write]');
  const form = root.querySelector('[data-cr-form]');
  const apply = () => {
    const q = (search?.value || '').trim().toLowerCase();
    const mode = sort?.value || '';
    let list = cards.slice();
    if (mode.includes('Highest')) list.sort((a, b) => Number(b.dataset.stars) - Number(a.dataset.stars));
    if (mode.includes('Lowest')) list.sort((a, b) => Number(a.dataset.stars) - Number(b.dataset.stars));
    const grid = root.querySelector('[data-cr-grid]');
    list.forEach((card) => grid.append(card));
    cards.forEach((card) => {
      const hit = !q || card.innerText.toLowerCase().includes(q);
      card.style.display = hit ? '' : 'none';
    });
  };
  search?.addEventListener('input', apply);
  sort?.addEventListener('change', apply);
  load?.addEventListener('click', () => {
    root.querySelectorAll('.cr-card.is-more').forEach((card) => {
      card.hidden = false;
      card.classList.remove('is-more');
    });
    load.remove();
  });
  write?.addEventListener('click', () => {
    if (!form) return;
    form.hidden = !form.hidden;
  });
  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    const ok = form.querySelector('.cr-form-ok');
    if (ok) ok.hidden = false;
    form.querySelectorAll('input, textarea, select, button[type="submit"]').forEach((el) => {
      el.disabled = true;
    });
  });
};
const setupStats = () => {
  document.querySelectorAll('[data-stats] [data-count]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const target = Number(el.getAttribute('data-count') || 0);
    const run = () => {
      let n = 0;
      const tick = () => {
        n += Math.max(1, Math.round(target / 24));
        if (n >= target) n = target;
        el.querySelector('b') ? (el.querySelector('b').textContent = `${n}%`) : (el.textContent = `${n}%`);
        el.style.setProperty('--pct', n);
        if (n < target) requestAnimationFrame(tick);
      };
      tick();
    };
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        run();
        io.disconnect();
      }
    }, { threshold: 0.4 });
    io.observe(el);
  });
};
const setupSticky = () => {
  const sticky = document.querySelector('[data-sticky-buy]');
  const form = document.querySelector('.bp-checkout');
  if (!sticky) return;
  const sync = () => {
    if (!form) {
      sticky.classList.toggle('is-on', window.scrollY > 520);
      return;
    }
    sticky.classList.toggle('is-on', form.getBoundingClientRect().bottom < 36);
  };
  sync();
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
};
const bootUi = () => {
  try { setupSliders(); } catch (e) {}
  try { setupReviewSlider(); } catch (e) {}
  try { setupCustomerReviews(); } catch (e) {}
  try { setupStats(); } catch (e) {}
  try { setupSticky(); } catch (e) {}
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootUi);
else bootUi();

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu]');
  if (toggle) document.querySelector('[data-nav]')?.classList.toggle('is-open');
});

const replaceCartWith = (id, qty = 1) => {
  const variantId = Number(id);
  const quantity = Number(qty) || 1;
  if (!variantId || !window.fetch) return Promise.resolve(null);
  return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
    .then(() => fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    }))
    .then((res) => {
      if (!res || !res.ok) {
        return res ? res.json().then((err) => Promise.reject(err)).catch(() => Promise.reject({})) : Promise.reject({});
      }
      return res.json();
    })
    .then((added) => fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then((cart) => {
        window.dispatchEvent(new CustomEvent('lift:cart', { detail: cart }));
        return { added, cart };
      }))
    .catch((err) => Promise.reject(err));
};

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-localization-select]');
  if (select) select.form?.submit();

  const offer = event.target.closest('[name="puffly-offer"]');
  if (!offer) return;
  window.__liftAbortSeed = true;
  const money = offer.getAttribute('data-money') || '';
  const qty = offer.getAttribute('data-qty') || '1';
  const id = offer.getAttribute('data-id');
  const qtyInput = document.querySelector('[data-offer-qty]');
  const idInput = document.querySelector('[data-offer-id]');
  const stickyBase = document.querySelector('[data-sticky-cta]')?.getAttribute('data-label') || 'ORDER LIFT';
  const labelSticky = `${stickyBase} — ${money}`;
  if (qtyInput) qtyInput.value = qty;
  if (idInput && id) idInput.value = id;
  document.querySelectorAll('.bp-offer').forEach((el) => {
    el.classList.toggle('is-on', el.contains(offer) && offer.checked);
  });
  document.querySelectorAll('[data-offer-btn]').forEach((el) => {
    if (el.tagName !== 'A' && el.tagName !== 'BUTTON') return;
    const base = el.getAttribute('data-label') || 'ORDER LIFT';
    el.textContent = `${base} — ${money}`;
  });
  document.querySelectorAll('[data-sticky-cta]').forEach((el) => {
    el.textContent = labelSticky;
  });
  if (id && !window.__liftCheckout) {
    window.__liftCartSync = replaceCartWith(id, qty).catch(() => null);
  }
});

const startCheckout = (trigger) => {
  if (window.__liftCheckout) return;
  window.__liftCheckout = true;
  window.__liftAbortSeed = true;
  const label = trigger ? trigger.textContent : '';
  const i18n = window.__liftI18n || {};
  if (trigger) {
    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    if ('textContent' in trigger) trigger.textContent = i18n.checkout || 'Going to checkout…';
  }
  const fail = (msg) => {
    window.__liftCheckout = false;
    if (trigger) {
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
      if ('textContent' in trigger) trigger.textContent = label || 'ORDER LIFT';
    }
    if (msg) window.alert(msg);
  };
  const idField = document.querySelector('[data-offer-id]');
  const qtyField = document.querySelector('[data-offer-qty]');
  const checked = document.querySelector('[name="puffly-offer"]:checked');
  const id = Number((checked && checked.getAttribute('data-id')) || (idField && idField.value) || 0);
  const qty = Number((checked && checked.getAttribute('data-qty')) || (qtyField && qtyField.value) || 1) || 1;
  if (!id) {
    fail(i18n.choose || 'Choose a pack first');
    return;
  }
  if (idField) idField.value = String(id);
  if (qtyField) qtyField.value = String(qty);
  ['cart', 'cart_ts', 'cart_sig'].forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${location.hostname}`;
  });
  const go = () => {
    replaceCartWith(id, qty)
      .then(() => { window.location.replace('/checkout'); })
      .catch((payload) => {
        fail((payload && (payload.description || payload.message)) || i18n.fail || 'Could not start checkout');
      });
  };
  // Wait for any in-flight pack sync, then replace again so checkout has only the selected pack.
  const pending = window.__liftCartSync && window.__liftCartSync.then ? window.__liftCartSync : Promise.resolve();
  pending.catch(() => null).finally(go);
};

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-offer-btn], [data-sticky-cta]');
  if (!btn) return;
  event.preventDefault();
  startCheckout(btn);
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('.buy-now-form');
  if (!form) return;
  event.preventDefault();
  startCheckout(form.querySelector('[data-offer-btn]'));
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-thumb]');
  if (!thumb) return;
  const main = document.querySelector('[data-main-image]');
  if (main) main.src = thumb.getAttribute('data-thumb');
  document.querySelectorAll('[data-thumb]').forEach((el) => el.classList.toggle('is-active', el === thumb));
});

const paintCartCount = (cart) => {
  const badge = document.querySelector('[data-cart-count]');
  if (!badge) return;
  const count = cart && cart.item_count ? cart.item_count : 0;
  badge.textContent = String(count);
  badge.hidden = count < 1;
};
window.addEventListener('lift:cart', (event) => paintCartCount(event.detail));
